/**
 * Onglet Gestion d'équipe - Prestataire Libre
 * Design identique à l'Accord Cadre (PJ1) :
 * - Section 1 : Membres de l'équipe (GestionComptesPrestataires)
 * - Section 2 : Affectation des membres sur les lots (GestionComptes)
 */
import React from 'react';
import GestionComptesPrestataires from '../../../composants/GestionComptesPrestataires/GestionComptesPrestataires';
// Ancien tableau d'affectation, remplace par la carte (AffectationCarte). Conserve pour revert.
// import GestionComptes from '../../../composants/GestionComptes/GestionComptes';
import AffectationCarte from '../../../composants/AffectationCarte/AffectationCarte';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import './TabEquipe.css';

const TabEquipe: React.FC = () => {
  return (
    <div className="tab-equipe">
      <SectionPliable title="Membres de l'équipe">
        <GestionComptesPrestataires />
      </SectionPliable>

      <SectionPliable title="Affectation des membres sur les lots">
        <AffectationCarte />
        {/* Ancien tableau d'affectation conserve pour revert eventuel : */}
        {/* <GestionComptes /> */}
      </SectionPliable>
    </div>
  );
};

export default TabEquipe;
